import {useEventContext} from "../../contexts/EventContext";
import Skeleton from "react-loading-skeleton";

const Product = ({ children }) => <>{children}</>;

const Image = () => {
    const { event } = useEventContext();
    return (
        <>
            {Object.keys(event).length !== 0 ? (
                <div className="esc-ii-aspect-w-14 esc-ii-aspect-h-7">
                    <img src={event.main_image} alt={event.name} className="esc-ii-w-full esc-ii-h-full esc-ii-object-center esc-ii-object-cover" />
                </div>
            ) : (
                <Skeleton />
            )}
        </>
    );
}

Product.Image = Image;
export default Product;
